<div class="chart-error">
  <app-icon title="Chart error" [size]="IconSize.MEDIUM">warning</app-icon>
  <p>{{ errorText }}</p>
</div>
